interface CustomIconEmailSharingProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconEmailSharing({ width, height, color = '#1C1C28', ...props }: CustomIconEmailSharingProps) {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.15576 3.77832C3.15576 3.22604 3.60348 2.77832 4.15576 2.77832H22C22.5523 2.77832 23 3.22604 23 3.77832V19.4883C23 20.0406 22.5523 20.4883 22 20.4883H4.15576C3.60348 20.4883 3.15576 20.0406 3.15576 19.4883V3.77832ZM5.15576 4.77832V18.4883H21V4.77832H5.15576Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.41053 3.11154C3.77879 2.69995 4.41098 2.66483 4.82257 3.03309L13.4746 10.7744L21.1778 3.07122C21.5684 2.6807 22.2015 2.6807 22.5921 3.07122C22.9826 3.46175 22.9826 4.09491 22.5921 4.48544L14.2199 12.8575C13.8447 13.2328 13.2416 13.2496 12.846 12.8957L3.48898 4.52357C3.07739 4.15531 3.04227 3.52312 3.41053 3.11154Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3226 14.2918L14 15.7478L18.8865 18.6603L18.2918 24.0359L27.3226 14.2918Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0231 15.5351C13.1145 15.115 13.4642 14.8004 13.8916 14.7537L27.2141 13.2978C27.6291 13.2524 28.0285 13.4695 28.2161 13.8424C28.4037 14.2153 28.3399 14.6655 28.0562 14.9716L19.0254 24.7156C18.7321 25.0321 18.2687 25.1248 17.8762 24.9453C17.4837 24.7659 17.2506 24.3548 17.2981 23.9259L17.822 19.1898L13.4882 16.6068C13.1189 16.3867 12.9317 15.9552 13.0231 15.5351ZM17.077 16.4175L19.3987 17.8013C19.7353 18.0019 19.9237 18.3807 19.8807 18.7702L19.6193 21.1326L24.7683 15.577L17.077 16.4175Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.338 15.41L19.3459 19.5485L18.4263 17.7725L26.4183 13.634L27.338 15.41Z"
        fill={color}
      />
    </svg>
  );
}
